import isString from "lodash/isString";
import { useSelector } from "react-redux";
import find from "lodash/find";

export const checkArtusRule = (optionIdentifier, heightIdentifier, supportBarIdentifier, widthIdentifier) => {
  const height = heightIdentifier && isString(heightIdentifier) ? Number(heightIdentifier.match(/\d+/)) : "";
  const width = widthIdentifier && isString(widthIdentifier) ? Number(widthIdentifier.match(/\d+/)) : "";
  const supportBars =
    supportBarIdentifier && isString(supportBarIdentifier) ? Number(supportBarIdentifier.match(/\d+/)) : "";
  const rules = {
    frontend_layers2: height > 5500,
    frontend_layers4: height < 4000,
    frontend_layers5: height < 6000,
    frontend_layers6: height < 6000,
    frontend_heightARTUS2500: supportBars > 3,
    frontend_heightARTUS3000: supportBars > 3,
    frontend_heightARTUS3500: supportBars > 3,
    frontend_heightARTUS4000: supportBars > 4,
    frontend_heightARTUS4500: supportBars > 4,
    frontend_heightARTUS5000: supportBars > 4,
    frontend_heightARTUS5500: supportBars > 4,
    frontend_heightARTUS6000: supportBars > 5 || supportBars < 3,
    frontend_heightARTUS6500: supportBars > 5 || supportBars < 3,
    frontend_heightARTUS7000: supportBars < 3,
    frontend_heightARTUS7500: supportBars < 3,
    frontend_shelfLoad2000: width !== 2700,
    frontend_shelfLoad3070: width !== 2700,
    frontend_shelfLoad3850: width !== 1900,
    frontend_shelfLoad4200: width !== 3600,
  };
  const rule = rules[optionIdentifier] || false;
  return rule;
};

export const checkBertWarehouseRule = (
  optionIdentifier,
  shelfLoadIdentifier,
  usableFromBothSides,
  color,
  depthIdentifier,
  fields = []
) => {
  const shelfLoad =
    shelfLoadIdentifier && isString(shelfLoadIdentifier)
      ? Number(shelfLoadIdentifier.match(/\d+/))
      : shelfLoadIdentifier;
  const hasPanel = find(fields, { rightPanel: true }) || find(fields, { leftPanel: true });
  const depth =
    depthIdentifier && isString(depthIdentifier) ? Number(depthIdentifier.match(/\d+/)) : depthIdentifier;
  const bertWarehouseRules = {
    frontend_shelfLoad80: color === "lightgrey" || depth === 400 || depth === 500 || depth === 800,
    frontend_shelfLoad350: color === "lightgrey" || depth === 800,
    lightgrey: shelfLoad === 80 || shelfLoad === 350,
    frontend_depth400: shelfLoad === 80,
    frontend_depth500: shelfLoad === 80,
    frontend_depth800: shelfLoad === 350 || shelfLoad === 80 || hasPanel,
  };
  const rule = bertWarehouseRules[optionIdentifier] || false;
  return !!rule;
};
